const REDS = [0, 2, 6, 7, 8];

export const isRed = (val) => {
  const result = REDS.includes(val);
  return result; 
};

export const isHigh = (val) => {
  return val > 5;
};
